/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { Button, Input, Label, Spacer, theme } from "@nordcloud/gnui";
import { FormGroup, stringRequired } from "~/components/Forms";
import { useUpdateCloudAccount } from "~/views/accounts/hooks";
import { CloudAccountFields } from "~/views/accounts/hooks/useUpdateCloudAccount/types";

export const schema = z.object({
  apiKey: stringRequired("API Key"),
});

type Props = {
  onSuccess: () => void;
};

export function IbmForm({ onSuccess }: Props) {
  const { handleSubmit, register, formState, reset } = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      apiKey: "",
    },
  });

  const [updateCloudAccount, loading] = useUpdateCloudAccount({
    onSuccess: () => {
      onSuccess();
      reset();
    },
  });

  const onSubmit = (data: CloudAccountFields) => updateCloudAccount(data);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormGroup error={formState.errors["apiKey"]}>
        <Label name="Provide API Key" htmlFor="apiKey" required />
        <Input
          type="password"
          id="apiKey"
          placeholder="e.g., XEogykgnehnuMKZUEM-abFxjK7uCNF9FOdBRI9-KgTMR"
          {...register("apiKey")}
        />
      </FormGroup>
      <Spacer height={theme.spacing.spacing02} />
      <Button initialState={loading ? "loading" : "success"}>Apply</Button>
    </form>
  );
}
